import { __decorate } from "tslib";
import { css, html } from 'lit';
import { customElement, property, query, state } from 'lit/decorators.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import '../../components/svgIcons.js';
import { subscribe } from '../../common/reactiveX/rxElementDecorators.js';
import { RxElement } from '../../common/reactiveX/rxElement.js';
import '../../common/loadingSpinner.js';
let FulfillmentActionSteps = class FulfillmentActionSteps extends RxElement {
    constructor() {
        super(...arguments);
        this.limit = 12;
        this.page = 1;
        this.paginationLimit = 11;
        this.paginationNumbers = [];
        this.filters = [];
        this.filterMapping = { All: [] };
        this.isLoading = false;
        this.copyAction = async (e) => {
            e.preventDefault();
            const id = e.target.getAttribute('data-id');
            const title = e.target.getAttribute('data-title');
            const slug = e.target.getAttribute('data-slug');
            const rank = e.target.getAttribute('data-rank');
            const href = e.target.getAttribute('href');
            const copyHtml = `<a data-type="action" data-id="${id}" data-rank="${rank}" data-title="${title}" data-slug="${slug}" href="${href}" target="_blank">${title}</a>`;
            const blob = Promise.resolve(new Blob([copyHtml], { type: 'text/html' }));
            // eslint-disable-next-line no-undef
            const item = new ClipboardItem({ 'text/html': blob });
            await navigator.clipboard.write([item]);
        };
    }
    connectedCallback() {
        // eslint-disable-next-line wc/guard-super-call
        super.connectedCallback();
        this.fetchActionSteps();
    }
    async fetchActionSteps() {
        this.isLoading = true;
        const headers = new Headers();
        headers.append('Authorization', `Bearer ${this.blueUser.accessToken}`);
        const results = await fetch(new Request(`${process.env.API_URL}/blue/actionitems`), {
            headers,
        });
        if (results.ok || results.status === 200) {
            const json = await results.json();
            this.actionSteps = json;
            this.steps = json;
            this.total = json.length;
            this.size = Math.ceil(json.length / this.limit);
            this.content = this.actionSteps.slice((this.page - 1) * this.limit, this.page * this.limit);
            this.buildFilter();
            this.generatePageNumbers();
            this.isLoading = false;
        }
        return null;
    }
    searchActionSteps() {
        const search = this._search.value.toLowerCase();
        const filter = this._filter.value.toLowerCase();
        if (filter === 'all milestones') {
            this.content = this.actionSteps;
        }
        else {
            this.content = this.steps;
        }
        const obj = this.content.filter(o => { var _a; return o.title.toLowerCase().includes(search) || ((_a = o.content) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(search)); });
        this.size = Math.ceil(obj.length / this.limit);
        this.content = obj.slice((this.page - 1) * this.limit, this.page * this.limit);
        this.page = 1;
        this.paginationNumbers = [];
        this.generatePageNumbers();
    }
    buildFilter() {
        this.filterMapping.All = this.actionSteps;
        this.actionSteps.forEach(o => {
            if (o.relatedMilestones.length) {
                o.relatedMilestones.forEach(m => {
                    const id = m.title.toString();
                    const keyExists = Object.keys(this.filterMapping).includes(id);
                    this.filters.push(id);
                    if (keyExists) {
                        this.filterMapping[id].push(o);
                    }
                    else {
                        this.filterMapping[id] = [o];
                    }
                });
            }
        });
        this.filters = [...new Set(this.filters)];
        this.filters.sort((a, b) => a.localeCompare(b));
        this.filters.unshift('All Milestones');
    }
    filterActionSteps() {
        const filter = this._filter.value;
        if (filter === 'All Milestones') {
            this.steps = this.actionSteps;
        }
        else {
            this.steps = this.filterMapping[filter];
        }
        this.size = Math.ceil(this.steps.length / this.limit);
        this.content = this.steps.slice((this.page - 1) * this.limit, this.page * this.limit);
        this.page = 1;
        this.paginationNumbers = [];
        this.generatePageNumbers();
    }
    paginate(e) {
        const pageAttribute = e.target.getAttribute('data-page');
        const page = pageAttribute ? parseInt(pageAttribute, 10) : 1;
        if (Number.isNaN(page)) {
            return;
        }
        this.page = page;
        this.paginationNumbers = [];
        this.generatePageNumbers();
        this.content = this.steps.slice((this.page - 1) * this.limit, this.page * this.limit);
    }
    generatePageNumbers() {
        this.paginationNumbers = [];
        const range = (start, stop, step) => Array.from({ length: (stop - start) / step + 1 }, (_, i) => (start + i * step).toString());
        if (this.size > this.paginationLimit) {
            const toPageLimit = this.size - this.page;
            const fromPageStart = this.page - 1;
            if (fromPageStart === 0 || fromPageStart <= this.paginationLimit - 4) {
                this.paginationNumbers.push(`0`);
                this.paginationNumbers.push(...range(1, this.paginationLimit - 3, 1));
                this.paginationNumbers.push(`...`);
                this.paginationNumbers.push(`${this.size - 1}`);
            }
            else if (toPageLimit === 0 || toPageLimit <= this.paginationLimit - 4) {
                this.paginationNumbers.push(`0`);
                this.paginationNumbers.push(`...`);
                this.paginationNumbers.push(...range(this.size - (this.paginationLimit - 2), this.size - 2, 1));
                this.paginationNumbers.push(`${this.size - 1}`);
            }
            else {
                if (toPageLimit === 1) {
                    this.paginationNumbers.push(`...`);
                    this.paginationNumbers.push(...range(this.size - (this.paginationLimit - 3), this.paginationLimit - 3, 1));
                }
                else if (fromPageStart === 1) {
                    this.paginationNumbers.push(`0`);
                    this.paginationNumbers.push(...range(this.page - 1, this.paginationLimit - 3, 1));
                    this.paginationNumbers.push(`...`);
                }
                else {
                    this.paginationNumbers.push(`0`);
                    this.paginationNumbers.push(`...`);
                    this.paginationNumbers.push(...range(this.page - 1 - 3, this.page - 1 + 3, 1));
                    this.paginationNumbers.push(`...`);
                }
                this.paginationNumbers.push(`${this.size - 1}`);
            }
        }
        else {
            [...Array(this.size).keys()].forEach(num => {
                this.paginationNumbers.push(`${num}`);
            });
        }
    }
    // eslint-disable-next-line class-methods-use-this
    noClick(e) {
        e.preventDefault();
    }
    render() {
        if (this.isLoading) {
            return html `<loading-spinner loadingText="Loading action steps..."></loading-spinner>`;
        }
        return html `
			<div class="search__bar">
				<svg class="search__icon">
					<use href="/static/icons.svg#search" xlink:href="/static/icons.svg#search" />
				</svg>
				<input type="text" id="action__search" @keyup="${this.searchActionSteps}" />
				${this.filters.length
            ? // eslint-disable-next-line lit-a11y/no-invalid-change-handler
                html `<select id="action__filter" @change="${this.filterActionSteps}">
							${this.filters.map(f => html `<option value="${f}">${unsafeHTML(f)}</option>`)};
					  </select>`
            : ''}
			</div>
			<div class="tab__content">
				${!this.content || !this.content.length
            ? html `<p class="none">No Action Steps Found</p>`
            : html `<h4>Action Steps</h4>
							${this.content.map(step => html `
									<details id="${step.id}">
										<summary>
											<p class="action__entry" draggable="true">
												<a
													data-type="action"
													data-id="${step.id}"
													data-rank="${step.rank}"
													data-title="${step.title}"
													data-slug="${step.slug}"
													class="draggable action"
													draggable="true"
													target="_blank"
													@click="${this.noClick}"
													@keyup="${this.noClick}"
													href="${process.env.HUB_DOMAIN}/?redir=/actionplan/${step.slug}"
													>${unsafeHTML(step.title)}</a
												>
												<a
													data-id="${step.id}"
													data-rank="${step.rank}"
													data-title="${step.title}"
													data-slug="${step.slug}"
													class="copy__action"
													@click="${this.copyAction}"
													@keyup="${this.copyAction}"
													href="${process.env.HUB_DOMAIN}/?redir=/actionplan/${step.slug}"
													>Copy</a
												>
											</p>
										</summary>
										<p class="action__content">
											${unsafeHTML(step.content)}
											${step.relatedMilestones.length
                ? html ` <p class="related__milestones">
														<strong>Related Milestones:</strong>
														${step.relatedMilestones.map(milestone => html `<br /><a
																		class="milestone"
																		target="_blank"
																		href="https://www.ffhub.com/?redir=/home/milestones/${milestone.id}"
																		>${milestone.title}</a
																	>`)}
												  </p>`
                : null}
										</p>
									</details>
								`)}`}
				<div class="paginate">
					<div class="paginate__numbers">
						${this.size
            ? (this.paginationNumbers,
                this.paginationNumbers.map(num => html `<span
											id="page${parseInt(num, 10) + 1}"
											data-page="${parseInt(num, 10) + 1}"
											@keyup="${this.paginate}"
											@click="${this.paginate}"
											class="page__number ${parseInt(num, 10) + 1 === this.page
                    ? 'page__selected'
                    : ''}"
											>${Number.isNaN(parseInt(num, 10)) ? num : parseInt(num, 10) + 1}</span
										>`))
            : ''}
					</div>
				</div>
			</div>
		`;
    }
};
FulfillmentActionSteps.styles = css `
		:host {
			width: 100%;
		}
		h4 {
			color: #073853;
			margin-left: 8px;
		}
		#action__filter {
			width: 50%;
			height: 34px;
			margin: 8px 20px;
			border-radius: 8px;
			border: 1px solid #d3d3d3;
			padding-left: 10px;
		}
		#action__search {
			width: 50%;
			height: 30px;
			margin: 8px 0 8px 20px;
			border-radius: 8px;
			border: 1px solid #d3d3d3;
			padding-left: 40px;
		}
		#action__search:focus,
		#action__filter:focus {
			outline: none;
			border-color: #007cab !important;
			border-width: 2px;
		}
		.search__bar {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 100%;
			background: #f7f7fa;
			height: 50px;
			border-top: 1px solid #efefef;
			border-bottom: 1px solid #efefef;
		}
		.tab__content {
			padding: 0 20px 20px;
		}
		.none {
			font-size: 14px;
			color: #383838;
		}
		.action__entry {
			width: 100%;
			margin: 0 0 0 20px;
			display: flex;
		}
		.milestone,
		.action,
		.copy__action {
			display: inline-block;
			text-decoration: none;
			color: #007cab;
			font-weight: 500;
			margin: 8px 0 8px 8px;
			font-size: 14px;
			min-width: 40px;
			height: 100%;
		}
		.milestone {
			margin: 0;
		}
		.action__content {
			font-size: 14px;
			color: #383838;
			margin: 0px;
		}
		.action__content p {
			padding: 10px 50px 0 30px;
			margin: 0px;
			line-height: 1.4em;
		}
		.action {
			width: 100%;
			cursor: pointer;
			text-decoration: none;
		}
		details:nth-child(even) {
			background: #f7f7fa !important;
		}
		.paginate {
			width: 100%;
		}
		.paginate__numbers {
			text-align: center;
			font-size: 14px;
			margin-top: 10px;
		}
		.page__number {
			padding: 2px 6px;
			margin: 0 3px 0 0;
			cursor: pointer;
			user-select: none;
		}
		.page__selected {
			background: #077cab;
			border-radius: 50%;
			color: #fff;
		}
		.search__icon {
			height: 25px;
			width: 25px;
			vertical-align: middle;
			position: relative;
			margin-right: -57px;
			margin-left: 32px;
		}
		.copy__action {
			font-weight: 500;
			color: #007cab;
			cursor: pointer;
		}
		summary {
			display: inline-flex;
			align-items: center;
			width: 100%;
		}
		summary:-webkit-details-marker,
		summary:marker {
			content: '';
		}
		summary:before {
			content: '›';
			color: #007cab;
			cursor: pointer;
			font-weight: 700;
			font-size: 24px !important;
			position: absolute;
			margin: -5px 0 0 10px;
		}
		details[open] {
			padding: 0 0 20px;
		}
		details[open] summary:before {
			content: '⌄';
			position: absolute;
			font-size: 20px !important;
			margin: -14px 0 0 10px;
		}
	`;
__decorate([
    subscribe(),
    state()
], FulfillmentActionSteps.prototype, "blueUser", void 0);
__decorate([
    property()
], FulfillmentActionSteps.prototype, "actionSteps", void 0);
__decorate([
    property()
], FulfillmentActionSteps.prototype, "steps", void 0);
__decorate([
    property()
], FulfillmentActionSteps.prototype, "content", void 0);
__decorate([
    query('#action__search')
], FulfillmentActionSteps.prototype, "_search", void 0);
__decorate([
    query('#action__filter')
], FulfillmentActionSteps.prototype, "_filter", void 0);
__decorate([
    property()
], FulfillmentActionSteps.prototype, "limit", void 0);
__decorate([
    property()
], FulfillmentActionSteps.prototype, "page", void 0);
__decorate([
    property()
], FulfillmentActionSteps.prototype, "paginationLimit", void 0);
__decorate([
    property()
], FulfillmentActionSteps.prototype, "paginationNumbers", void 0);
__decorate([
    property()
], FulfillmentActionSteps.prototype, "size", void 0);
__decorate([
    property()
], FulfillmentActionSteps.prototype, "total", void 0);
__decorate([
    property()
], FulfillmentActionSteps.prototype, "filters", void 0);
__decorate([
    property()
], FulfillmentActionSteps.prototype, "filterMapping", void 0);
__decorate([
    state()
], FulfillmentActionSteps.prototype, "isLoading", void 0);
FulfillmentActionSteps = __decorate([
    customElement('fulfillment-action-steps')
], FulfillmentActionSteps);
export { FulfillmentActionSteps };
//# sourceMappingURL=actionSteps.js.map